<div class="table entity-connection-group-table event-list" [ngClass]="{ 'disabled': isSubmitting }">
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <p class="col__ align--center vert-0100 bot-0100" *ngIf="calendarDays.length === 0">
    {{ loading ? 'Loading...' : 'No events found.'}}
  </p>
  <ng-container *ngIf="calendarDays.length > 0">
    <ng-container *ngFor="let day of calendarDays; let d = index;">

      <!-- Day header -->
      <div class="day-header tr tr--noGutter d-flex flexJustify--between" *ngIf="showDateHeader">
        <h5>{{day.date | date:'EEEE, M/d'}}</h5>
        <div *ngIf="!entityId && showDayCounts" class="float-r d-flex">
          <h5 class="txt-fw-500 spacerLeft">
            {{day.events.length}}
            {{day.events.length > 1 ? "events" : "event"}}
          </h5>
          <div [matMenuTriggerFor]="dayRsvpMenu" class="event-attendees spacerLeft"
            *ngIf="dayTotalAttending(day.events) > 0">
            {{dayTotalAttending(day.events)}}</div>

          <mat-menu #dayRsvpMenu="matMenu">
            <button mat-menu-item (click)="runEventResponseQuery(day.events, attendedResponses)">
              <strong>
                <a class="link">
                  {{ dayTotalAttending(day.events) }}
                  {{ (dateIsPast(day.date) ? 'attended': 'attending') }}
                </a>
              </strong>
            </button>
            <!-- Attending -->
            <ng-container *ngFor="let response of attendedResponses;">
              <button mat-menu-item *ngIf="sum(day.events, response) > 0"
                (click)="runEventResponseQuery(day.events, [response])">
                <i class="far fa-fw spacerRight {{ getIconWithColor(response) }}"></i>
                <a class="link">{{ getLabelForCount(sum(day.events, response), response) }}</a>
              </button>
            </ng-container>
            <!-- Not attending or tentative -->
            <ng-container *ngIf="dayTotalNotAttending(day.events) > 0">
              <mat-divider></mat-divider>
              <ng-container *ngFor="let response of notAttendedResponses;">
                <button mat-menu-item *ngIf="sum(day.events, response) > 0"
                  (click)="runEventResponseQuery(day.events, [response])">
                  <i class="far fa-fw spacerRight {{ getIconWithColor(response) }}"></i>
                  <a class="link">{{ getLabelForCount(sum(day.events, response), response) }}</a>
                </button>
              </ng-container>
            </ng-container>
          </mat-menu>
        </div>
      </div>

      <!-- Event row -->
      <div class="tr-wrapper">
        <ng-container *ngFor="let eventResult of day.events;">
          <div class="tr tr--noGutter"
            [ngClass]="{'expanded': eventsExpanded[eventResult.id] || (expandTagsByDefault && eventsExpanded[eventResult.id] !== false)}">
            <div class="col__ {{entityId ? 'col__entity-status-and-date' : 'col__event-date'}}">

              <!-- Icon to switch statuses -->
              <ng-container *ngIf="entityId">

                <div class="c-pointer d-inline-block mr-0100" [matMenuTriggerFor]="rsvpMenu">
                  <i
                    class="far fa-fw {{ eventResult.entityResponse?.status ? getIconWithColor(eventResult.entityResponse?.status) : 'fa-minus-circle color--gray--004' }}"></i>
                  <i class="fa-solid fa-angle-down ml-0025 color--gray fa-xs"></i>
                </div>

                <mat-menu #rsvpMenu="matMenu" yPosition="below">
                  <!-- If no response, show as current selection (disabled) -->
                  <button mat-menu-item *ngIf="!eventResult.entityResponse || !eventResult.entityResponse.status"
                    [disabled]="true">
                    <i class="far fa-fw fa-minus-circle color--gray--004 spacerRight"></i>
                    <a>No response</a>
                  </button>
                  <!-- Current response, if any, disabled -->
                  <button mat-menu-item *ngIf="eventResult.entityResponse && eventResult.entityResponse.status"
                    [disabled]="true">
                    <i class="far fa-fw {{ getIconWithColor(eventResult.entityResponse.status) }} spacerRight"></i>
                    <a>{{ getLabelPast(eventResult.entityResponse.status) }}</a>
                  </button>
                  <!-- Other response options -->
                  <ng-container *ngFor="let response of responseOptions;">
                    <button mat-menu-item *ngIf="showResponseOption(eventResult, response)" class="mat-option txt-14"
                      (click)="updateEventStatus(eventResult, response)">
                      <i class="far fa-fw {{ getIconWithColor(response) }} spacerRight"></i>
                      <a>{{ getLabel(response) }}</a>
                    </button>
                  </ng-container>
                </mat-menu>
              </ng-container>

              <small class="link link--sm" (click)="viewEvent(eventResult.id)">{{eventResult.startDate |
                date:'shortTime'}}</small>
            </div>
            <a class="flex event-title">
              <strong [ngClass]="{'clickable': !entityId, 'spacerRight':true}" (click)="viewEvent(eventResult.id)">{{eventResult.name}}</strong>
              <span *ngIf="isMultipleDays(eventResult)" class="txt-12 color--gray--009 nowrap spacerRight">
                Ends {{eventResult.endDate | date:'shortDate'}}
              </span>
            </a>

            <!-- Tag dropdown -->
            <ng-container *ngIf="(entityId && !taskButtons) || (taskButtons && !showTaskButtons(eventResult))">
              <div class="tc trContact__controls ml-auto right"
                (click)="eventsExpanded[eventResult.id] = (!eventsExpanded[eventResult.id] && !(expandTagsByDefault && eventsExpanded[eventResult.id] !== false) ? true : false)">
                <button type="button" class="drawer__btn hide-expanded ml-0050 color--gray">
                  <i class="far fa-fw fa-tags"></i>
                </button>
                <button type="button" class="drawer__btn show-expanded ml-0050 color--gray">
                  <i class="far fa-fw fa-chevron-down"></i>
                </button>
              </div>
            </ng-container>

            <!-- Task buttons -->
            <div class="task-buttons" *ngIf="taskButtons && showTaskButtons(eventResult)"
              [ngClass]="{'two-buttons': showAttendanceButtons(eventResult)}">
              <button class="btn btn--sm btn--white spacerRight" (click)="noShowEvent(eventResult)"
                *ngIf="showAttendanceButtons(eventResult)">
                <i class="far fa-fw {{ getIcon(ResponseTypes.NoShow) }}"></i>
                <span>{{ getLabelPast(ResponseTypes.NoShow) }}</span>
              </button>
              <button class="btn btn--sm" (click)="updateEvent(eventResult)">
                <i class="far fa-fw {{ getIcon(getTaskButtonResponse(eventResult)) }}"></i>
                <span>
                  {{ getLabel(getTaskButtonResponse(eventResult)) }}
                </span>
              </button>
            </div>

            <!-- RSVP/attending count -->
            <div class="float-r" *ngIf="showRsvps && eventTotalAttending(eventResult) > 0">
              <div [matMenuTriggerFor]="rsvpMenu" class="event-attendees">
                {{ eventTotalAttending(eventResult) }}
              </div>

              <mat-menu #rsvpMenu="matMenu">
                <button mat-menu-item *ngIf="eventTotalAttending(eventResult) > 0"
                  (click)="runEventResponseQuery(day.events, attendedResponses)">
                  <strong>
                    <a class="link">
                      {{ totalAttendingLabel(eventResult) }}
                    </a>
                  </strong>
                </button>
                <ng-container *ngFor="let response of attendedResponses;">
                  <button mat-menu-item *ngIf="eventResponseCount(eventResult, response) > 0"
                    (click)="runEventResponseQuery(day.events, [response])">
                    <i class="far fa-fw spacerRight {{ getIconWithColor(response) }}"></i>
                    <a class="link">{{ getLabelForCount(eventResponseCount(eventResult, response), response) }}</a>
                  </button>
                </ng-container>
                <ng-container *ngIf="eventTotalNotAttending(eventResult) > 0">
                  <mat-divider></mat-divider>
                  <ng-container *ngFor="let response of notAttendedResponses;">
                    <button mat-menu-item *ngIf="eventResponseCount(eventResult, response) > 0"
                      (click)="runEventResponseQuery(day.events, [response])">
                      <i class="far fa-fw spacerRight {{ getIconWithColor(response) }}"></i>
                      <a class="link">{{ getLabelForCount(eventResponseCount(eventResult, response), response) }}</a>
                    </button>
                  </ng-container>
                </ng-container>
              </mat-menu>
            </div>

          </div>
          <span *ngIf="entityId==false"></span>
          <div class="tr--expansion"
            [ngClass]="{'d-none': !eventsExpanded[eventResult.id] && !(expandTagsByDefault && eventsExpanded[eventResult.id] !== false) }"
            *ngIf="entityId">
            <div class="event-response-tags-container">
              <app-event-response-tags [calendarEvent]="eventResult"
                [calendarEventResponse]="eventResult.entityResponse"></app-event-response-tags>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>
